var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',[_c('v-card',{attrs:{"color":"card1"}},[_c('v-card-title',[_vm._v("Home")])],1),_c('vue-clock',{staticClass:"mx-16 my-8 d-flex justify-center"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }